/**
 * Renders the club images hero on the home page, making a ClubsHeroIndividual component for each club
 */
import React, {useState} from "react";
import HomeClubIndividual from "./HomeClubIndividual";
import { useQuery } from '@tanstack/react-query'
import Loading from "../core/Loading";

const ClubsHero = () => {
    const { isLoading, error, data} = useQuery({
        staleTime: Infinity,
        queryKey: ['clubs'],
        queryFn: () =>
            fetch(`${process.env.REACT_APP_BUIHA_API_URL}/club/all/`).then((res) =>
                res.json(),
            ),
    });

    if (isLoading)
        return (
          <Loading height={52} />
        );
        

    if (error) return 'An error has occurred: ' + error.message;

    data && data.sort((a, b) => (a.name > b.name ? 1 : -1));

    return (
        <div className="my-1 dark:icons1:mt-2 flex flex-row flex-wrap justify-center items-center">

            {data.map((club) => (

                // If club.status == active, then show the club
                club.status === "Active" ? (
                    <HomeClubIndividual
                        id={club.stub}
                        name={club.name}
                        logo={club.logo.md}
                    />
                ) : (
                    <></>
                )
            ))}
        </div>
    );
}
export default ClubsHero;